import Boundaries from './Boundaries'

export default Boundaries
